import styled from "styled-components";

export const Color = styled.div`
   background-color: ${(props) => props.color};
   height: 1.5rem;
   width: 1.5rem;
   border-radius: 9999px;
`;
